var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ExistingItems',{attrs:{"items":_vm.items,"title":"Φίλτρα Ομάδας"},scopedSlots:_vm._u([(_vm.items.length)?{key:"item",fn:function(props){return [_c('router-link',{attrs:{"to":{
        name: 'products.filterGroups.filters.edit',
        params: {
          uuid: props.item.filter_group.uuid,
          filter: props.item.uuid,
        },
      }}},[_vm._v(" "+_vm._s(props.item.title)+" ")])]}}:{key:"default",fn:function(undefined){return _c('p',[_vm._v("Δε βρέθηκαν αποτελέσματα")])}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }